import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const storedLang = typeof window !== 'undefined' ? localStorage.getItem('chcc_language') : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: storedLang || undefined,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    debug: false,
    defaultNS: 'home',
    ns: ['home'],
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'chcc_language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;